import {
  NetworkStatus,
  useNetworkStatus,
} from "$global-providers/network-status-provider/provider";
import { Header } from "$routes/_lib/layout/header";
import { SideMenuProvider } from "$routes/_lib/layout/side-menu/context";
import { usePreventUnloadWhenUnsynced } from "$routes/_lib/layout/use-prevent-unload-when-unsynced";
import { styled } from "@material-ui/core";
import { Outlet } from "react-router-dom";
import { OfflineOnFirstLoadPage } from "./_lib/layout/offline-on-first-load-page";

const StyledHeader = styled(Header)(({ theme }) => ({
  position: "sticky",
  top: 0,
  zIndex: theme.zIndex.drawer + 1,
}));

export const AppLayout: FCwC = ({ children = <Outlet /> }) => {
  const { networkStatus, isOfflineOnFirstLoad } = useNetworkStatus();

  // Prevent page unload when there is unsynced data
  usePreventUnloadWhenUnsynced();

  return (
    <SideMenuProvider>
      <StyledHeader
        offlineStatus={
          isOfflineOnFirstLoad
            ? "initiallyOffline"
            : networkStatus === NetworkStatus.OFFLINE
              ? "offline"
              : "online"
        }
      />
      {isOfflineOnFirstLoad ? <OfflineOnFirstLoadPage /> : children}
    </SideMenuProvider>
  );
};
